import "./css/App.css";
import Header from "../src/frontend/components/Header";
import Footer from "../src/frontend/components/Footer";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollToTop from "./frontend/components/ScrollToTop";
import LandingPage from "./frontend/pages/LandingPage";
import AboutUs from "./frontend/pages/AboutUs";
import ServicesPage from "./frontend/pages/Services";
import ContactUsPage from "./frontend/pages/ContactUs";
import PrivacyPage from "./frontend/pages/PrivacyPolicy";
import FeesPage from "./frontend/pages/Fees";
import BlogsPage from "./frontend/pages/BlogsPage";
import Blog1 from "./frontend/pages/Blogs/Blog1";
import Blog2 from "./frontend/pages/Blogs/Blog2";
import Blog3 from "./frontend/pages/Blogs/Blog3";
import Blog4 from "./frontend/pages/Blogs/Blog4";
import Blog5 from "./frontend/pages/Blogs/Blog5";
import Blog6 from "./frontend/pages/Blogs/Blog6";
import Blog7 from "./frontend/pages/Blogs/Blog7";
import Blog8 from "./frontend/pages/Blogs/Blog8";
import Blog9 from "./frontend/pages/Blogs/Blog9";
import Blog10 from "./frontend/pages/Blogs/Blog10";
import Blog11 from "./frontend/pages/Blogs/Blog11";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/fees" element={<FeesPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blogs/1" element={<Blog1 />} />
          <Route path="/blogs/2" element={<Blog2/>} />
          <Route path="/blogs/3" element={<Blog3 />} />
          <Route path="/blogs/4" element={<Blog4 />} />
          <Route path="/blogs/5" element={<Blog5 />} />
          <Route path="/blogs/6" element={<Blog6 />} />
          <Route path="/blogs/7" element={<Blog7 />} />
          <Route path="/blogs/8" element={<Blog8 />} />
          <Route path="/blogs/9" element={<Blog9 />} />
          <Route path="/blogs/10" element={<Blog10 />} />
          <Route path="/blogs/11" element={<Blog11 />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
